import { c as _c } from "react/compiler-runtime";
import { Suspense } from 'react';
export default function SuspenseWrapper(t0) {
  const $ = _c(3);
  const {
    children,
    fallback
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== fallback) {
    t1 = <Suspense fallback={fallback}>{children}</Suspense>;
    $[0] = children;
    $[1] = fallback;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}